export default "ALTER TABLE `financings` ADD `kind` text DEFAULT 'financing' NOT NULL;\n";